export const AUTH0_TYPES = {
  TWITTER: "Twitter",
  GOOGLE: "Google",
  FACEBOOK: "Facebook",
  APPLE: "Apple",
  OUTLOOK: "Outlook",
}
